export default __webpack_public_path__ + "static/media/background.4e92d074.mp4";